/* Card behaviour: the price markup, the saved list, and the two hover controls.

   This is its own file rather than more weight in oh-core.js because all of it belongs to
   the product card as an object, and because three surfaces build their own card markup in
   JS and cannot render a Liquid snippet: the cross-sell strip (oh-product.js), predictive
   search (oh-search.js) and the finder plan (oh-finder.js).

   Loads after oh-core.js, so OH.qs, OH.store, OH.toast and OH.cart are already attached. */
window.OH = window.OH || {};

(function () {
  /* ---------- price ----------
     The JS twin of snippets/oh-price.liquid. Takes whole dollars, not cents, because the
     callers arrive with different units: cents from the recommendations API, decimal strings
     from predictive search and the collection JSON. Each converts once at its own call site
     rather than passing a flag around.

     Returns a plain price unless there is a genuine markdown, so a missing or equal
     compare-at can never produce an empty strike or a "0% off" badge. That also covers
     finder plans restored from localStorage, which were saved before compare-at existed and
     carry no such key at all. */
  OH.priceHTML = function (now, was) {
    const n = Number(now) || 0;
    const w = Number(was) || 0;
    /* Matches Liquid's money_without_trailing_zeros: cents when there are cents, none when
       there are not. Rounding to whole dollars here would print $600 on the saved page next
       to $599.99 on the catalog page for the same piece. */
    const money = d => {
      const r = Math.round(d * 100) / 100;
      return "$" + (r % 1 === 0
        ? r.toLocaleString("en-US")
        : r.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    };
    const pct = w > n ? Math.round((w - n) / w * 100) : 0;
    if (pct <= 0) return '<span class="price-now">' + money(n) + "</span>";
    return '<span class="sr-only">Regular price</span>' +
           '<s class="price-strike">' + money(w) + "</s>" +
           '<span class="sr-only">Sale price</span>' +
           '<span class="price-now">' + money(n) + "</span>" +
           '<span class="price-save">Save ' + money(w - n) + "</span>";
  };

  /* ---------- saved ----------
     Stores handles and nothing else. The saved page fetches /products/{handle}.js for each
     one, so what it shows is the live price and availability rather than whatever happened
     to be true on the day the shopper hearted it. A wishlist is small, so those fetches run
     in parallel and cost one request per saved piece. */
  OH.saved = {
    list() {
      const v = OH.store.get("saved", []);
      return Array.isArray(v) ? v.filter(h => typeof h === "string" && h) : [];
    },
    has(handle) { return this.list().indexOf(handle) > -1; },
    count() { return this.list().length; },
    /* Returns true when the piece ended up saved, false when it came off the list. */
    toggle(handle) {
      const l = this.list();
      const i = l.indexOf(handle);
      if (i > -1) l.splice(i, 1); else l.unshift(handle);
      OH.store.set("saved", l);
      document.dispatchEvent(new CustomEvent("oh:saved"));
      return i === -1;
    },
    remove(handle) {
      OH.store.set("saved", this.list().filter(h => h !== handle));
      document.dispatchEvent(new CustomEvent("oh:saved"));
    },
    add(handle) {
      if (this.has(handle)) return;
      OH.store.set("saved", [handle].concat(this.list()));
      document.dispatchEvent(new CustomEvent("oh:saved"));
    }
  };

  /* Liquid cannot read localStorage, so every card renders unsaved and this fills in the
     hearts once the shell is up. Takes an optional root so it can run on a subtree that has
     just been injected. */
  OH.paintSaved = function (root) {
    const list = OH.saved.list();
    OH.qsa("[data-wish]", root).forEach(btn => {
      const on = list.indexOf(btn.getAttribute("data-wish")) > -1;
      btn.classList.toggle("saved", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
  };

  /* refreshBadges in oh-core.js is module-private and only knows about the bag, so the
     saved count is painted here. */
  function paintSavedBadge() {
    const n = OH.saved.count();
    const el = OH.qs("[data-saved-count]");
    if (!el) return;
    el.textContent = n;
    el.classList.toggle("show", n > 0);
    const link = el.closest("a");
    if (link) link.setAttribute("aria-label", "Saved, " + n + (n === 1 ? " piece" : " pieces"));
  }

  /* Both controls sit inside the card anchor, so they have to stop the click before it
     navigates to the product page. */
  document.addEventListener("click", e => {
    const wish = e.target.closest("[data-wish]");
    if (wish) {
      e.preventDefault();
      e.stopPropagation();
      const handle = wish.getAttribute("data-wish");
      const saved = OH.saved.toggle(handle);
      if (OH.track) OH.track(saved ? "add_to_wishlist" : "remove_from_wishlist", { item_handle: handle });
      return;
    }
    const qadd = e.target.closest("[data-qadd]");
    if (qadd) {
      e.preventDefault();
      e.stopPropagation();
      const id = parseInt(qadd.getAttribute("data-qadd"), 10);
      if (id) OH.cart.add(id, 1, qadd);
    }
  });

  function boot() {
    OH.paintSaved();
    paintSavedBadge();
  }

  document.addEventListener("oh:saved", () => { OH.paintSaved(); paintSavedBadge(); });
  document.addEventListener("DOMContentLoaded", boot);
  if (document.readyState !== "loading") boot();
})();
